import { useMemo } from "react";

import type { DataFullstoryId } from "@citrine/types/full-story";

const loadFullStory = () => import("./full-story");

type EventProperties = Record<string, any>;

declare module "react" {
  interface HTMLAttributes<T>
    extends React.AriaAttributes, React.DOMAttributes<T> {
    "data-fullstoryid"?: DataFullstoryId;
  }
}

export function useEvent(): (
  eventId: DataFullstoryId,
  eventProperties?: EventProperties,
) => Promise<void>;
export function useEvent(
  eventId: DataFullstoryId,
): (eventProperties?: EventProperties) => Promise<void>;
export function useEvent(eventId?: DataFullstoryId) {
  return useMemo(() => {
    async function event(
      _eventId: DataFullstoryId,
      eventProperties: EventProperties = {},
    ) {
      const FullStory = await loadFullStory();
      return FullStory.event(_eventId, eventProperties);
    }

    return eventId ? event.bind(null, eventId) : event;
  }, [eventId]);
}
